import React from "react"
import { connect } from "react-redux"
import Switch from "react-switch"
import {
  editMenuItem,
  openDeleteFeatureModal,
  openFeatureNotificationModal,
  setSelectedFeature,
} from "store/actions"
import { showToast } from "utils"
import { fetchMenuItem, publishWarningText } from "./utils"

const MenuFeaturesListActionsToggle = ({
  feature,
  editMenuItem,
  isEventFeature,
  openDeleteFeatureModal,
  eventId,
  eventStatus,
  openFeatureNotificationModal,
  setEditParams,
}) => {
  const hasAtLeastOnePublished = data => {
    for (let i = 0; i < data?.length; i++) {
      if (data[i]?.status) {
        return true
      }
    }
    return false
  }

  const updateMenuStatus = feature => {
    editMenuItem({
      data: {
        delete_image: 0,
        image_file: null,
        label: feature.label,
        menu_item_id: feature.id,
        status: !feature.status,
      },
      type: isEventFeature ? "event" : "landing",
    })
  }

  const handleStatusChange = async status => {
    if (!status || feature?.machine_name === "media") {
      updateMenuStatus(feature)
    }
    if (status && feature?.type === 1) {
      if (!feature?.entity_id) {
        showToast(
          "error",
          "The feature can not be published until you create the feature.",
          "Feature entry is not created"
        )
      } else {
        if (isEventFeature) {
          if (eventStatus) {
            setEditParams({
              delete_image: 0,
              image_file: null,
              label: feature.label,
              menu_item_id: feature.id,
              status: !feature.status,
            })
            openFeatureNotificationModal()
          } else {
            updateMenuStatus(feature)
          }
        } else {
          setEditParams({
            delete_image: 0,
            image_file: null,
            label: feature.label,
            menu_item_id: feature.id,
            status: !feature.status,
          })
          openFeatureNotificationModal()
        }
      }
    } else {
      if (status && feature?.machine_name !== "media") {
        const items = await fetchMenuItem(feature, eventId)

        if (items) {
          if (
            ([
              "calendar",
              "booking_service",
              "view_bookings",
              "refer_friend",
              "places",
            ].indexOf(feature?.machine_name) === -1 &&
              !feature?.can_create &&
              (items?.length === 0 || !hasAtLeastOnePublished(items))) ||
            ([
              "calendar",
              "booking_service",
              "view_bookings",
              "refer_friend",
              "places",
            ].indexOf(feature?.machine_name) !== -1 &&
              !items?.menu_item_id)
          ) {
            showToast(
              "error",
              publishWarningText(feature?.machine_name, items),
              "Error"
            )
          } else {
            updateMenuStatus(feature)
          }
        } else {
          updateMenuStatus(feature)
        }
      }
    }
  }

  const editHandler = () => {
    console.log("edit clicked")
  }

  return (
    <span className="d-flex">
      <Switch
        checked={feature.status}
        onChange={status => handleStatusChange(status)}
        onColor="#2ECC71"
        offColor="#E74C3C"
        name="publishCheck"
        uncheckedIcon={false}
        checkedIcon={false}
        height={17}
        width={27}
        handleDiameter={13}
      />
      <i
        className="bx bx-sm bx-edit font-size-20"
        style={{ marginLeft: "10px", cursor: "pointer" }}
        onClick={event => {
          editHandler()
        }}
      />
      <i
        className="bx bx-sm bx-trash font-size-20"
        style={{ marginLeft: "8px", cursor: "pointer" }}
        onClick={event => {
          openDeleteFeatureModal()
        }}
      />
    </span>
  )
}

const mapDispatchToProps = dispatch => ({
  editMenuItem: values => dispatch(editMenuItem(values)),
  setSelectedFeature: feature => dispatch(setSelectedFeature(feature)),
  openDeleteFeatureModal: () => dispatch(openDeleteFeatureModal()),
  openFeatureNotificationModal: () => dispatch(openFeatureNotificationModal()),
})

export default connect(null, mapDispatchToProps)(MenuFeaturesListActionsToggle)
